const baseStyleButton = {
    px: '1rem',
    py: '0.5rem',
};
const variantMedium = ({ colorScheme: c, }) => {
    return {
        button: {
            p: '1rem',
            _hover: {
                color: `${c}.600`,
                bg: 'initial',
            },
            _active: {
                color: `${c}.700`,
            },
            _focusVisible: {
                boxShadow: `0 0 0 2px var(--chakra-colors-${c}-500)`,
            },
        },
    };
};
const baseStyle = {
    button: baseStyleButton,
};
const variants = {
    medium: variantMedium,
};
export const Accordion = {
    baseStyle,
    variants,
    defaultProps: {
        colorScheme: 'brand.primary',
    },
};
